import { create } from "zustand";

const useModalsStore = create((set: any, get: any) => ({
  showCreateNewAccount: false,
  showCreateNewTask: false,
  showCreateNewLink: false,
  showEditProfile: false,
  showEditAccount: "",
  showDeleteHistoryConfirm: false,
  showLogoutDialog: false,
  showCreateNewCanvas: false,
  showMoneyTransferModal: false,
  showSearchModal: false,
  showTableSettingsModal: false,
  showContactQrCode: false,
  showCreatePassKey: false,
  showChangePassword: false,

  setShowCreateNewAccount: (isVisible: boolean) => {
    set({ showCreateNewAccount: isVisible });
  },

  setShowChangePassword: (isVisible: boolean) => {
    set({ showChangePassword: isVisible });
  },

  setShowCreatePassKey: (isVisible: boolean) => {
    set({ showCreatePassKey: isVisible });
  },

  setShowContactQrCode: (isVisible: boolean) => {
    set({ showContactQrCode: isVisible });
  },

  setShowCreateNewTask: (isVisible: boolean) => {
    set({ showCreateNewTask: isVisible });
  },

  setShowCreateNewCanvas: (isVisible: boolean) => {
    set({ showCreateNewCanvas: isVisible });
  },

  setShowCreateNewLink: (isVisible: boolean) => {
    set({ showCreateNewLink: isVisible });
  },

  setShowEditProfile: (isVisible: boolean) => {
    set({ showEditProfile: isVisible });
  },

  setShowEditAccount: (accountId: string) => {
    set({ showEditAccount: accountId });
  },

  setShowDeleteHistoryConfirm: (isVisible: boolean) => {
    set({ showDeleteHistoryConfirm: isVisible });
  },

  setShowLogoutDialog: (isVisible: boolean) => {
    set({ showLogoutDialog: isVisible });
  },

  setShowMoneyTransferModal: (isOpen: boolean) => {
    set({ showMoneyTransferModal: isOpen });
  },

  setShowSearchModal: (isOpen: boolean) => {
    set({ showSearchModal: isOpen });
  },

  setShowTableSettingsModal: (isOpen: boolean) => {
    set({ showTableSettingsModal: isOpen });
  },
}));

export default useModalsStore;
